export const MAX_IMAGE_UPLOAD_COUNT = 3;
